module.exports = __webpack_public_path__ + "static/media/Nila gumbat.2fe7ba85.jpeg";